/* eslint-disable import/prefer-default-export */
import React from 'react';

const defaultFill = '#474D66';

// TODO: @ayhan fill'in düzgün çalışması için tüm svg ler ListUnordered gibi ayarlanmalı.

export const ArrowDownIcon = ({
    width = '16px',
    height = '16px',
    style,
    viewBox = '0 0 24 24',
    fill
}) => {
    return (
        <svg
            idth={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path
                d="M5.99968 5.07437L10.5372 0.536865L11.8334 1.83303L5.99968 7.6667L0.166016 1.83303L1.46218 0.536865L5.99968 5.07437Z"
                fill={fill || defaultFill}
            />
        </svg>
    );
};

export const ArrowUpLineIcon = ({
    width = '16px',
    height = '16px',
    style,
    viewBox = '0 0 24 24',
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path
                d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z"
                fill={fill || defaultFill}
            />
        </svg>
    );
};

export const ArrowDownLineIcon = ({
    width = '16px',
    height = '16px',
    style,
    viewBox = '0 0 24 24',
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path
                d="M13 16.172l5.364-5.364 1.414 1.414L12 20l-7.778-7.778 1.414-1.414L11 16.172V4h2v12.172z"
                fill={fill || defaultFill}
            />
        </svg>
    );
};

export const LanguageIcon = ({
    width = '16px',
    height = '16px',
    style,
    viewBox = '0 0 24 24',
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.235 4.453C2.96004 5.77629 2.1795 7.49815 2.02457 9.32917C1.86964 11.1602 2.34977 12.9887 3.38426 14.5074C4.41874 16.0261 5.94451 17.1424 7.70511 17.6686C9.46571 18.1948 11.3538 18.0989 13.052 17.397C13.167 16.647 12.915 15.927 12.812 15.675C12.582 15.115 11.824 14.158 10.559 12.831C10.221 12.476 10.243 12.203 10.364 11.394L10.377 11.303C10.459 10.749 10.597 10.421 12.462 10.125C13.41 9.975 13.659 10.353 14.004 10.878L14.12 11.05C14.448 11.53 14.691 11.64 15.058 11.806C15.223 11.881 15.428 11.976 15.703 12.131C16.355 12.504 16.355 12.925 16.355 13.847V13.952C16.355 14.343 16.317 14.687 16.257 14.986C17.0244 14.0229 17.5591 12.8957 17.8196 11.6922C18.0801 10.4886 18.0593 9.24122 17.7588 8.04703C17.4584 6.85284 16.8863 5.7441 16.0873 4.80714C15.2883 3.87017 14.2838 3.13026 13.152 2.645C12.599 3.018 11.84 3.547 11.575 3.91C11.44 4.095 11.248 5.042 10.625 5.12C10.463 5.14 10.244 5.126 10.012 5.111C9.39 5.071 8.54 5.016 8.268 5.755C8.095 6.223 8.065 7.495 8.624 8.155C8.714 8.26 8.731 8.455 8.67 8.674C8.59 8.961 8.429 9.136 8.378 9.172C8.282 9.116 8.09 8.893 7.959 8.742C7.646 8.377 7.254 7.922 6.748 7.782C6.564 7.731 6.362 7.689 6.165 7.647C5.616 7.532 4.995 7.401 4.85 7.093C4.744 6.867 4.745 6.556 4.745 6.228C4.745 5.811 4.745 5.34 4.541 4.883C4.47008 4.71991 4.36585 4.57344 4.235 4.453ZM10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20Z"
                fill={fill || defaultFill}
            />
        </svg>
    );
};

export const UserProfileIcon = ({
    width = '16px',
    height = '16px',
    style,
    viewBox = '0 0 24 24',
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0 21C0 18.8783 0.842855 16.8434 2.34315 15.3431C3.84344 13.8429 5.87827 13 8 13C10.1217 13 12.1566 13.8429 13.6569 15.3431C15.1571 16.8434 16 18.8783 16 21H14C14 19.4087 13.3679 17.8826 12.2426 16.7574C11.1174 15.6321 9.5913 15 8 15C6.4087 15 4.88258 15.6321 3.75736 16.7574C2.63214 17.8826 2 19.4087 2 21H0ZM8 12C4.685 12 2 9.315 2 6C2 2.685 4.685 0 8 0C11.315 0 14 2.685 14 6C14 9.315 11.315 12 8 12ZM8 10C10.21 10 12 8.21 12 6C12 3.79 10.21 2 8 2C5.79 2 4 3.79 4 6C4 8.21 5.79 10 8 10Z"
                fill={fill || defaultFill}
            />
        </svg>
    );
};

export const SwitchAccountIcon = ({
    width = '16px',
    height = '16px',
    style,
    viewBox = '0 0 24 24',
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18ZM5 11H14V13H10V16L5 11ZM10 7V4L15 9H6V7H10Z"
                fill={fill || defaultFill}
            />
        </svg>
    );
};

export const LogOutIcon = ({
    width = '16px',
    height = '16px',
    style,
    viewBox = '0 0 24 24',
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 2.81829e-06 10 2.81829e-06C11.5527 -0.00116364 13.0842 0.359775 14.4729 1.05414C15.8617 1.74851 17.0693 2.75718 18 4H15.29C14.1352 2.98176 12.7112 2.31836 11.1887 2.0894C9.66625 1.86044 8.11007 2.07566 6.70689 2.70922C5.30371 3.34277 4.11315 4.36776 3.27807 5.66119C2.44299 6.95462 1.99887 8.46153 1.999 10.0011C1.99913 11.5407 2.4435 13.0475 3.27879 14.3408C4.11409 15.6341 5.30482 16.6589 6.7081 17.2922C8.11139 17.9255 9.66761 18.1405 11.19 17.9113C12.7125 17.6821 14.1364 17.0184 15.291 16H18.001C17.0702 17.243 15.8624 18.2517 14.4735 18.9461C13.0846 19.6405 11.5528 20.0013 10 20ZM17 14V11H9V9H17V6L22 10L17 14Z"
                fill={fill || defaultFill}
            />
        </svg>
    );
};

export const SearchIcon = ({
    width = '16px',
    height = '16px',
    style,
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16.031 14.617L20.314 18.899L18.899 20.314L14.617 16.031C13.0237 17.3082 11.042 18.0029 9 18C4.032 18 0 13.968 0 9C0 4.032 4.032 0 9 0C13.968 0 18 4.032 18 9C18.0029 11.042 17.3082 13.0237 16.031 14.617ZM14.025 13.875C15.2941 12.5699 16.0029 10.8204 16 9C16 5.132 12.867 2 9 2C5.132 2 2 5.132 2 9C2 12.867 5.132 16 9 16C10.8204 16.0029 12.5699 15.2941 13.875 14.025L14.025 13.875Z"
                fill={fill || defaultFill}
            />
        </svg>
    );
};

export const LayoutGridFill = ({
    width = '16px',
    height = '16px',
    style,
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M22 12.999V20a1 1 0 0 1-1 1h-8v-8.001h9zm-11 0V21H3a1 1 0 0 1-1-1v-7.001h9zM11 3v7.999H2V4a1 1 0 0 1 1-1h8zm10 0a1 1 0 0 1 1 1v6.999h-9V3h8z" />
        </svg>
    );
};

export const ListUnordered = ({
    width = '16px',
    height = '16px',
    style,
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M8 4h13v2H8V4zM4.5 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 6.9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM8 11h13v2H8v-2zm0 7h13v2H8v-2z" />
        </svg>
    );
};

export const CreateIcon = ({
    width = '16px',
    height = '16px',
    style,
    viewBox,
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M1 0H17C17.2652 0 17.5196 0.105357 17.7071 0.292893C17.8946 0.48043 18 0.734784 18 1V17C18 17.2652 17.8946 17.5196 17.7071 17.7071C17.5196 17.8946 17.2652 18 17 18H1C0.734784 18 0.48043 17.8946 0.292893 17.7071C0.105357 17.5196 0 17.2652 0 17V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0ZM2 2V16H16V2H2ZM8 8V4H10V8H14V10H10V14H8V10H4V8H8Z" />
        </svg>
    );
};

export const InformationLine = ({
    width = '16px',
    height = '16px',
    style,
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM11 7h2v2h-2V7zm0 4h2v6h-2v-6z" />
        </svg>
    );
};

export const Store3Fill = ({
    width = '16px',
    height = '16px',
    style,
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M21 13v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-7H2v-2l1-5h18l1 5v2h-1zM5 13v6h14v-6H5zm1 1h8v3H6v-3zM3 3h18v2H3V3z" />
        </svg>
    );
};

export const MapPinFill = ({
    width = '16px',
    height = '16px',
    style,
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M18.364 17.364L12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0zM12 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm0-2a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" />
        </svg>
    );
};

export const ImageFill = ({ width = '16px', height = '16px', style, fill }) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M20 5H4v14l9.292-9.294a1 1 0 0 1 1.414 0L20 15.01V5zM2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993zM8 11a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" />
        </svg>
    );
};

export const Building2Fill = ({
    width = '16px',
    height = '16px',
    style,
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M12 19h2V6l6.394 2.74a1 1 0 0 1 .606.92V19h2v2H1v-2h2V5.65a1 1 0 0 1 .594-.914l7.703-3.424A.5.5 0 0 1 12 1.77V19z" />
        </svg>
    );
};

export const CheckboxCircleFill = ({
    width = '16px',
    height = '16px',
    style,
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-.997-6l7.07-7.071-1.414-1.414-5.656 5.657-2.829-2.829-1.414 1.414L11.003 16z" />
        </svg>
    );
};

export const CheckLine = ({ width = '16px', height = '16px', style, fill }) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z" />
        </svg>
    );
};

export const ImageAddFill = ({
    width = '16px',
    height = '16px',
    style,
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            style={style}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M21 15v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2zm.008-12c.548 0 .992.445.992.993v9.349A5.99 5.99 0 0 0 20 13V5H4l.001 14 9.292-9.293a.999.999 0 0 1 1.32-.084l.093.085 3.546 3.55a6.003 6.003 0 0 0-3.91 7.743L2.992 21A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3h18.016zM8 7a2 2 0 1 1 0 4 2 2 0 0 1 0-4z" />
        </svg>
    );
};

export const AddBoxLine = ({
    width = '16px',
    height = '16px',
    style,
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            style={style}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm1 2v14h14V5H5zm6 6V7h2v4h4v2h-4v4h-2v-4H7v-2h4z" />
        </svg>
    );
};

export const SignalTowerFill = ({
    width = '16px',
    height = '16px',
    style,
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            style={style}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M6.116 20.087A9.986 9.986 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10a9.986 9.986 0 0 1-4.116 8.087l-1.015-1.739a8 8 0 1 0-9.738 0l-1.015 1.739zm2.034-3.485a6 6 0 1 1 7.7 0l-1.03-1.766a4 4 0 1 0-5.64 0l-1.03 1.766zM11 13h2l1 9h-4l1-9z" />
        </svg>
    );
};

export const EarthLine = ({ width = '16px', height = '16px', style, fill }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            style={style}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M6.235 6.453a8 8 0 0 0 8.817 12.944c.115-.75-.137-1.47-.24-1.722-.23-.56-.988-1.517-2.253-2.844-.338-.355-.316-.628-.195-1.437l.013-.091c.082-.554.22-.882 2.085-1.178.948-.15 1.197.228 1.542.753l.116.172c.328.48.571.59.938.756.165.075.37.17.645.325.652.373.652.794.652 1.716v.105c0 .391-.038.735-.098 1.034a8.002 8.002 0 0 0-3.105-12.341c-.553.373-1.312.902-1.577 1.265-.135.185-.327 1.132-.95 1.21-.162.02-.381.006-.613-.009-.622-.04-1.472-.095-1.744.644-.173.468-.203 1.74.356 2.4.09.105.107.3.046.519-.08.287-.241.462-.292.498-.096-.056-.288-.279-.419-.43-.313-.365-.705-.82-1.211-.96-.184-.051-.386-.093-.583-.135-.549-.115-1.17-.246-1.315-.554-.106-.226-.105-.537-.105-.865 0-.417 0-.888-.204-1.345a1.276 1.276 0 0 0-.306-.43zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" />
        </svg>
    );
};

export const TimeLine = ({ width = '16px', height = '16px', style, fill }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            style={style}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm1-8h4v2h-6V7h2v5z" />
        </svg>
    );
};

export const OilLevelIcon = ({
    width = '16px',
    height = '16px',
    style,
    viewBox = '0 0 24 24',
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M2 13C2 14.3261 2.52678 15.5979 3.46447 16.5355C4.40215 17.4732 5.67392 18 7 18C8.32608 18 9.59785 17.4732 10.5355 16.5355C11.4732 15.5979 12 14.3261 12 13C12 11.274 10.34 7.969 7 3.347C3.66 7.969 2 11.274 2 13ZM7 0C11.667 6.09 14 10.423 14 13C14 14.8565 13.2625 16.637 11.9497 17.9497C10.637 19.2625 8.85652 20 7 20C5.14348 20 3.36301 19.2625 2.05025 17.9497C0.737498 16.637 0 14.8565 0 13C0 10.423 2.333 6.09 7 0Z" />
        </svg>
    );
};

export const SoundIcon = ({
    width = '16px',
    height = '16px',
    style,
    viewBox = '0 0 24 24',
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 2C8.20435 2 7.44129 2.31607 6.87868 2.87868C6.31607 3.44129 6 4.20435 6 5V11C6 11.7956 6.31607 12.5587 6.87868 13.1213C7.44129 13.6839 8.20435 14 9 14C9.79565 14 10.5587 13.6839 11.1213 13.1213C11.6839 12.5587 12 11.7956 12 11V5C12 4.20435 11.6839 3.44129 11.1213 2.87868C10.5587 2.31607 9.79565 2 9 2ZM9 0C9.65661 0 10.3068 0.129329 10.9134 0.380602C11.52 0.631876 12.0712 1.00017 12.5355 1.46447C12.9998 1.92876 13.3681 2.47995 13.6194 3.08658C13.8707 3.69321 14 4.34339 14 5V11C14 12.3261 13.4732 13.5979 12.5355 14.5355C11.5979 15.4732 10.3261 16 9 16C7.67392 16 6.40215 15.4732 5.46447 14.5355C4.52678 13.5979 4 12.3261 4 11V5C4 3.67392 4.52678 2.40215 5.46447 1.46447C6.40215 0.526784 7.67392 0 9 0V0ZM0 11.03C0 10.7648 0.105357 10.5104 0.292893 10.3229C0.48043 10.1354 0.734784 10.03 1 10.03C1.26522 10.03 1.51957 10.1354 1.70711 10.3229C1.89464 10.5104 2 10.7648 2 11.03C2 12.8786 2.73434 14.6514 4.04147 15.9585C5.34859 17.2657 7.12144 18 8.97 18H9.03C10.8786 18 12.6514 17.2657 13.9585 15.9585C15.2657 14.6514 16 12.8786 16 11.03C16 10.7648 16.1054 10.5104 16.2929 10.3229C16.4804 10.1354 16.7348 10.03 17 10.03C17.2652 10.03 17.5196 10.1354 17.7071 10.3229C17.8946 10.5104 18 10.7648 18 11.03C18 13.409 17.0549 15.6905 15.3727 17.3727C13.6905 19.0549 11.409 20 9.03 20H8.97C6.59101 20 4.30945 19.0549 2.62725 17.3727C0.945051 15.6905 0 13.409 0 11.03H0Z" />
        </svg>
    );
};

export const NoiseIcon = ({
    width = '16px',
    height = '16px',
    style,
    viewBox = '0 0 24 24',
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M12 2H11.4C11.1301 2.0001 10.8631 2.05482 10.6149 2.16085C10.3667 2.26689 10.1426 2.42205 9.956 2.617L6.239 6.5H2V11.5H6.239L9.956 15.383C10.1426 15.5779 10.3667 15.7331 10.6149 15.8391C10.8631 15.9452 11.1301 15.9999 11.4 16H12V2ZM5.385 4.5L8.51 1.234C8.88358 0.843743 9.33234 0.533205 9.82921 0.32112C10.3261 0.109035 10.8608 -0.000201486 11.401 2.78993e-07H13C13.2652 2.78993e-07 13.5196 0.105357 13.7071 0.292893C13.8946 0.48043 14 0.734784 14 1V17C14 17.2652 13.8946 17.5196 13.7071 17.7071C13.5196 17.8946 13.2652 18 13 18H11.4C10.8601 17.9999 10.3258 17.8906 9.82929 17.6785C9.33278 17.4664 8.88434 17.156 8.511 16.766L5.385 13.5H2C1.46957 13.5 0.960859 13.2893 0.585786 12.9142C0.210714 12.5391 0 12.0304 0 11.5V6.5C0 5.96957 0.210714 5.46086 0.585786 5.08579C0.960859 4.71071 1.46957 4.5 2 4.5H5.385ZM16 7C15.7348 7 15.4804 6.89464 15.2929 6.70711C15.1054 6.51957 15 6.26522 15 6C15 5.73478 15.1054 5.48043 15.2929 5.29289C15.4804 5.10536 15.7348 5 16 5C17.0609 5 18.0783 5.42143 18.8284 6.17157C19.5786 6.92172 20 7.93913 20 9C20 10.0609 19.5786 11.0783 18.8284 11.8284C18.0783 12.5786 17.0609 13 16 13C15.7348 13 15.4804 12.8946 15.2929 12.7071C15.1054 12.5196 15 12.2652 15 12C15 11.7348 15.1054 11.4804 15.2929 11.2929C15.4804 11.1054 15.7348 11 16 11C16.5304 11 17.0391 10.7893 17.4142 10.4142C17.7893 10.0391 18 9.53043 18 9C18 8.46957 17.7893 7.96086 17.4142 7.58579C17.0391 7.21071 16.5304 7 16 7ZM16 3C15.7348 3 15.4804 2.89464 15.2929 2.70711C15.1054 2.51957 15 2.26522 15 2C15 1.73478 15.1054 1.48043 15.2929 1.29289C15.4804 1.10536 15.7348 1 16 1C18.1217 1 20.1566 1.84286 21.6569 3.34315C23.1571 4.84344 24 6.87827 24 9C24 11.1217 23.1571 13.1566 21.6569 14.6569C20.1566 16.1571 18.1217 17 16 17C15.7348 17 15.4804 16.8946 15.2929 16.7071C15.1054 16.5196 15 16.2652 15 16C15 15.7348 15.1054 15.4804 15.2929 15.2929C15.4804 15.1054 15.7348 15 16 15C17.5913 15 19.1174 14.3679 20.2426 13.2426C21.3679 12.1174 22 10.5913 22 9C22 7.4087 21.3679 5.88258 20.2426 4.75736C19.1174 3.63214 17.5913 3 16 3Z" />
        </svg>
    );
};

export const FlowIcon = ({
    width = '16px',
    height = '16px',
    style,
    viewBox = '0 0 24 24',
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M2 9V12.5C2 13.4283 2.36875 14.3185 3.02513 14.9749C3.6815 15.6313 4.57174 16 5.5 16H6.5C7.42826 16 8.3185 15.6313 8.97487 14.9749C9.63125 14.3185 10 13.4283 10 12.5V9H2ZM8 7V1C8 0.734784 8.10536 0.48043 8.29289 0.292893C8.48043 0.105357 8.73478 0 9 0C9.26522 0 9.51957 0.105357 9.70711 0.292893C9.89464 0.48043 10 0.734784 10 1V7C10.5304 7 11.0391 7.21071 11.4142 7.58579C11.7893 7.96086 12 8.46957 12 9V12.5C11.9999 13.7247 11.5911 14.9144 10.8385 15.8805C10.0859 16.8467 9.03244 17.5342 7.845 17.834C7.95836 18.0628 8.01145 18.3167 7.99925 18.5717C7.98704 18.8267 7.90995 19.0744 7.77527 19.2913C7.64058 19.5082 7.45277 19.6871 7.2296 19.8111C7.00644 19.9352 6.75531 20.0002 6.5 20H5.5C5.24469 20.0002 4.99356 19.9352 4.7704 19.8111C4.54723 19.6871 4.35942 19.5082 4.22473 19.2913C4.09005 19.0744 4.01296 18.8267 4.00075 18.5717C3.98855 18.3167 4.04164 18.0628 4.155 17.834C2.96756 17.5342 1.9141 16.8467 1.16148 15.8805C0.408868 14.9144 0.000126002 13.7247 0 12.5L0 9C0 8.46957 0.210714 7.96086 0.585786 7.58579C0.960859 7.21071 1.46957 7 2 7V1C2 0.734784 2.10536 0.48043 2.29289 0.292893C2.48043 0.105357 2.73478 0 3 0C3.26522 0 3.51957 0.105357 3.70711 0.292893C3.89464 0.48043 4 0.734784 4 1V7H8Z" />
        </svg>
    );
};

export const VoltageIcon = ({
    width = '16px',
    height = '16px',
    style,
    viewBox = '0 0 24 24',
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M8.997 6.968H6.708V3C6.708 2.73478 6.60264 2.48043 6.41511 2.29289C6.22757 2.10536 5.97322 2 5.708 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V8.923C1.99985 9.18243 2.10053 9.43176 2.28077 9.61835C2.46102 9.80494 2.70672 9.91418 2.966 9.923L4.903 9.984V17.388C4.90338 17.5142 4.94721 17.6363 5.02711 17.734C5.107 17.8316 5.21809 17.8988 5.34168 17.9241C5.46527 17.9495 5.59382 17.9315 5.7057 17.8732C5.81759 17.8149 5.90598 17.7198 5.956 17.604L9.916 8.362C9.98123 8.20983 10.0077 8.04384 9.99292 7.87893C9.97817 7.71402 9.92271 7.55536 9.83151 7.41717C9.74031 7.27899 9.61623 7.16561 9.4704 7.08721C9.32458 7.00882 9.16157 6.96785 8.996 6.968H8.997ZM8.708 3V4.968H8.997C9.49331 4.96813 9.98184 5.09138 10.4188 5.32673C10.8558 5.56208 11.2275 5.90216 11.5007 6.3165C11.774 6.73084 11.9401 7.20649 11.9843 7.70084C12.0285 8.19518 11.9494 8.69276 11.754 9.149L7.794 18.392C7.56242 18.931 7.15198 19.3737 6.63195 19.6453C6.11192 19.9168 5.51413 20.0007 4.93944 19.8827C4.36475 19.7648 3.84835 19.4522 3.47736 18.9977C3.10637 18.5432 2.90351 17.9747 2.903 17.388V11.922C2.12446 11.8968 1.38623 11.5698 0.84446 11.0101C0.302689 10.4504 -0.000147577 9.70195 5.39515e-08 8.923V3C5.39515e-08 2.20435 0.316071 1.44129 0.87868 0.87868C1.44129 0.31607 2.20435 0 3 0L5.708 0C6.50365 0 7.26671 0.31607 7.82932 0.87868C8.39193 1.44129 8.708 2.20435 8.708 3Z" />
        </svg>
    );
};

export const TemperatureIcon = ({
    width = '16px',
    height = '16px',
    style,
    viewBox = '0 0 24 24',
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M10 15C10 15.8523 9.78214 16.6904 9.36711 17.4348C8.95208 18.1792 8.35365 18.8052 7.62866 19.2533C6.90366 19.7013 6.07616 19.9566 5.22474 19.9949C4.37332 20.0333 3.52624 19.8533 2.76393 19.4721C2.00163 19.091 1.34941 18.5213 0.8692 17.8172C0.388993 17.1131 0.0967447 16.2979 0.0202049 15.449C-0.0563349 14.6002 0.085375 13.7459 0.431878 12.9672C0.778381 12.1885 1.31817 11.5114 2 11V3C2 2.20435 2.31607 1.44129 2.87868 0.87868C3.44129 0.31607 4.20435 0 5 0C5.79565 0 6.55871 0.31607 7.12132 0.87868C7.68393 1.44129 8 2.20435 8 3V11C9.214 11.912 10 13.364 10 15ZM6.799 12.599L6 11.999V3C6 2.73478 5.89464 2.48043 5.70711 2.29289C5.51957 2.10536 5.26522 2 5 2C4.73479 2 4.48043 2.10536 4.29289 2.29289C4.10536 2.48043 4 2.73478 4 3V11.999L3.201 12.599C2.69704 12.9766 2.3247 13.5033 2.13674 14.1044C1.94878 14.7054 1.95473 15.3504 2.15375 15.9478C2.35278 16.5453 2.73477 17.065 3.24562 17.4333C3.75646 17.8016 4.37025 17.9998 5 17.9998C5.62976 17.9998 6.24354 17.8016 6.75439 17.4333C7.26523 17.065 7.64723 16.5453 7.84625 15.9478C8.04527 15.3504 8.05122 14.7054 7.86326 14.1044C7.6753 13.5033 7.30296 12.9766 6.799 12.599ZM5 17C4.46957 17 3.96086 16.7893 3.58579 16.4142C3.21072 16.0391 3 15.5304 3 15C3 14.4696 3.21072 13.9609 3.58579 13.5858C3.96086 13.2107 4.46957 13 5 13C5.53043 13 6.03914 13.2107 6.41422 13.5858C6.78929 13.9609 7 14.4696 7 15C7 15.5304 6.78929 16.0391 6.41422 16.4142C6.03914 16.7893 5.53043 17 5 17Z" />
        </svg>
    );
};

export const VibrationIcon = ({
    width = '16px',
    height = '16px',
    style,
    className,
    viewBox = '0 0 24 24',
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M7.116 11.749L6 2.948L4.884 11.748H1C0.448 11.748 0 11.311 0 10.772C0.00316508 10.5098 0.110239 10.2595 0.297721 10.0762C0.485203 9.89281 0.737774 9.79133 1 9.794H3.116L4.016 2.708C4.15 1.636 5.15 0.875997 6.245 1.008C7.155 1.118 7.871 1.818 7.984 2.708L8.883 9.794H10.857L12 17.04L13.142 9.795H19C19.552 9.795 20 10.233 20 10.773C20 11.313 19.552 11.75 19 11.75H14.858L13.977 17.337C13.9081 17.7517 13.7089 18.1336 13.4082 18.4274C13.1076 18.7213 12.7212 18.9116 12.305 18.971C11.213 19.136 10.192 18.404 10.023 17.337L9.143 11.75H7.115L7.116 11.749Z" />
        </svg>
    );
};

export const SettingsIcon = ({
    width = '16px',
    height = '16px',
    style,
    viewBox = '0 0 24 24',
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M2.132 13.63a9.942 9.942 0 0 1 0-3.26c1.102.026 2.092-.502 2.477-1.431.385-.93.058-2.004-.74-2.763a9.942 9.942 0 0 1 2.306-2.307c.76.798 1.834 1.125 2.764.74.93-.385 1.457-1.376 1.43-2.477a9.942 9.942 0 0 1 3.262 0c-.027 1.102.501 2.092 1.43 2.477.93.385 2.004.058 2.763-.74a9.942 9.942 0 0 1 2.307 2.306c-.798.76-1.125 1.834-.74 2.764.385.93 1.376 1.457 2.477 1.43a9.942 9.942 0 0 1 0 3.262c-1.102-.027-2.092.501-2.477 1.43-.385.93-.058 2.004.74 2.763a9.942 9.942 0 0 1-2.306 2.307c-.76-.798-1.834-1.125-2.764-.74-.93.385-1.457 1.376-1.43 2.477a9.942 9.942 0 0 1-3.262 0c.027-1.102-.501-2.092-1.43-2.477-.93-.385-2.004-.058-2.763.74a9.942 9.942 0 0 1-2.307-2.306c.798-.76 1.125-1.834.74-2.764-.385-.93-1.376-1.457-2.477-1.43zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
        </svg>
    );
};

export const ShutDownLine = ({
    width = '16px',
    height = '16px',
    style,
    viewBox = '0 0 24 24',
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M6.265 3.807l1.147 1.639a8 8 0 1 0 9.176 0l1.147-1.639A9.988 9.988 0 0 1 22 12c0 5.523-4.477 10-10 10S2 17.523 2 12a9.988 9.988 0 0 1 4.265-8.193zM11 12V2h2v10h-2z" />
        </svg>
    );
};

export const TimeFill = ({
    width = '16px',
    height = '16px',
    style,
    viewBox = '0 0 24 24',
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm1-10V7h-2v7h6v-2h-4z" />
        </svg>
    );
};

export const AddCircle = ({
    width = '16px',
    height = '16px',
    style,
    viewBox = '0 0 24 24',
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-11H7v2h4v4h2v-4h4v-2h-4V7h-2v4z" />
        </svg>
    );
};

export const CloseFill = ({
    width = '16px',
    height = '16px',
    style,
    viewBox = '0 0 24 24',
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z" />
        </svg>
    );
};

export const ErrorWarningFill = ({
    width = '16px',
    height = '16px',
    style,
    viewBox = '0 0 24 24',
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-7v2h2v-2h-2zm0-8v6h2V7h-2z" />
        </svg>
    );
};

export const CapleType = ({
    width = '22px',
    height = '24px',
    style,
    viewBox = '0 0 22 24'
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
        >
            <path
                d="M1.56813 0.0843749C1.09 0.257812 0.705627 0.65625 0.588439 1.10156C0.560314 1.20469 0.546252 1.44844 0.555627 1.64062C0.588439 2.21719 0.879064 2.64375 1.43219 2.91562L1.64781 3.02344H9.47594H17.3041L17.5713 2.89219C17.8619 2.75156 18.1103 2.50312 18.2744 2.19375C18.3681 2.02031 18.3822 1.92188 18.3822 1.52344C18.3822 1.125 18.3681 1.02656 18.2744 0.853125C18.1103 0.54375 17.8619 0.295312 17.5713 0.154687L17.3041 0.0234375L9.54625 0.0140624C2.32281 0.00468731 1.77438 0.00937486 1.56813 0.0843749Z"
                fill="white"
            />
            <path
                d="M2.75 5.625V6.79688H9.47656H16.2031V5.625V4.45312H9.47656H2.75V5.625Z"
                fill="white"
            />
            <path
                d="M19.3484 4.997C19.0016 5.09075 18.6828 5.27357 18.425 5.52669C18.1484 5.79857 18.0172 6.0095 17.8813 6.3845C17.7828 6.67044 17.7781 6.7595 17.75 8.77513C17.7266 10.7954 17.7219 10.8751 17.6281 11.0017C17.5766 11.072 17.4594 11.1704 17.3703 11.2126C17.2203 11.2923 16.7703 11.297 9.98281 11.297H2.75V12.0001V12.7033H10.0297C17.9844 12.7033 17.5719 12.7173 18.0875 12.4361C18.65 12.1314 19.0672 11.4986 19.1562 10.8283C19.1797 10.6361 19.2031 9.65169 19.2031 8.64388C19.2031 6.81575 19.2031 6.81107 19.3109 6.65169C19.4891 6.3845 19.6625 6.32825 20.3281 6.32825C20.9938 6.32825 21.1672 6.272 21.3453 6.00482C21.5703 5.672 21.4391 5.1845 21.0781 5.00638C20.8625 4.89857 19.7375 4.89388 19.3484 4.997Z"
                fill="white"
            />
            <path
                d="M2.75 9V9.79688H9.47656H16.2031V9V8.20312H9.47656H2.75V9Z"
                fill="white"
            />
            <path
                d="M2.75 15V15.7969H9.47656H16.2031V15V14.2031H9.47656H2.75V15Z"
                fill="white"
            />
            <path
                d="M2.75 18.375V19.5469H9.47656H16.2031V18.375V17.2031H9.47656H2.75V18.375Z"
                fill="white"
            />
            <path
                d="M1.56813 21.0375C1.09 21.2109 0.705627 21.6094 0.588439 22.0547C0.560314 22.1578 0.546252 22.4016 0.555627 22.5937C0.588439 23.1703 0.879064 23.5969 1.43219 23.8687L1.64781 23.9766H9.47594H17.3041L17.5713 23.8453C17.8619 23.7047 18.1103 23.4562 18.2744 23.1469C18.3681 22.9734 18.3822 22.875 18.3822 22.4766C18.3822 22.0781 18.3681 21.9797 18.2744 21.8062C18.1103 21.4969 17.8619 21.2484 17.5713 21.1078L17.3041 20.9766L9.54625 20.9672C2.32281 20.9578 1.77438 20.9625 1.56813 21.0375Z"
                fill="white"
            />
        </svg>
    );
};

export const FileListFill = ({
    width = '16px',
    height = '16px',
    style,
    viewBox = '0 0 24 24',
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M20 22H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1zM8 7v2h8V7H8zm0 4v2h8v-2H8zm0 4v2h8v-2H8z" />
        </svg>
    );
};

export const DefaultComponentIcon = ({
    width = '16px',
    height = '16px',
    style,
    viewBox = '0 0 24 24',
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M8.99977 12V9H10.9998V12H15.9998C16.265 12 16.5193 12.1054 16.7069 12.2929C16.8944 12.4804 16.9998 12.7348 16.9998 13V19C16.9998 19.2652 16.8944 19.5196 16.7069 19.7071C16.5193 19.8946 16.265 20 15.9998 20H3.99977C3.73455 20 3.4802 19.8946 3.29266 19.7071C3.10512 19.5196 2.99977 19.2652 2.99977 19V13C2.99977 12.7348 3.10512 12.4804 3.29266 12.2929C3.4802 12.1054 3.73455 12 3.99977 12H8.99977ZM0.509766 6.837C1.83477 2.864 5.58377 0 9.99977 0C14.4158 0 18.1658 2.864 19.4898 6.837L17.5918 7.469C17.0605 5.87573 16.0414 4.49 14.6788 3.50805C13.3162 2.5261 11.6793 1.99771 9.99977 1.99771C8.32024 1.99771 6.68329 2.5261 5.32073 3.50805C3.95817 4.49 2.93907 5.87573 2.40777 7.469L0.510766 6.837H0.509766ZM4.30577 8.102C4.70462 6.90741 5.46909 5.86853 6.49096 5.13239C7.51284 4.39625 8.74035 4.00015 9.99977 4.00015C11.2592 4.00015 12.4867 4.39625 13.5086 5.13239C14.5304 5.86853 15.2949 6.90741 15.6938 8.102L13.7958 8.735C13.5299 7.93861 13.0202 7.24602 12.339 6.75526C11.6577 6.2645 10.8394 6.00043 9.99977 6.00043C9.16016 6.00043 8.34181 6.2645 7.66056 6.75526C6.97931 7.24602 6.46967 7.93861 6.20377 8.735L4.30577 8.102ZM4.99977 14V18H14.9998V14H4.99977Z" />
        </svg>
    );
};

export const AddLine = ({
    width = '16px',
    height = '16px',
    style,
    viewBox = '0 0 24 24',
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z" />
        </svg>
    );
};

export const Download2Line = ({
    width = '16px',
    height = '16px',
    style,
    viewBox = '0 0 24 24',
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M13 10h5l-6 6-6-6h5V3h2v7zm-9 9h16v-7h2v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-8h2v7z" />
        </svg>
    );
};

export const Upload2Line = ({
    width = '16px',
    height = '16px',
    style,
    viewBox = '0 0 24 24',
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M4 19h16v-7h2v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-8h2v7zm9-10v7h-2V9H6l6-6 6 6h-5z" />
        </svg>
    );
};

export const DeleteBin7Line = ({
    width = '16px',
    height = '16px',
    style,
    viewBox = '0 0 24 24',
    fill
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={style}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            fill={fill || defaultFill}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M17 6h5v2h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3zm1 2H6v12h12V8zM9 4v2h6V4H9z" />
        </svg>
    );
};
